import React from "react";
import { zl, zaokr } from "../../../functions/utilities.js";

const MieszkaniecDaneWodaRozliczenieMetraz = props => {
    
    const { procent } = props;

    return (
        <div className="metraz">
            <p>
                {`powierzchnia lokalu `}
                <span>{`${procent?.metraz} m²`}</span>
            </p>
        </div>
    )
}

export default MieszkaniecDaneWodaRozliczenieMetraz;